import { useRef, useState } from "react"
import Draggable from "react-draggable"

const IprIcon2 = (props) => {
  // const [position, setPosition] = useState({ x: 0, y: 0 })
  const [dragOffsetX, setDragOffsetX] = useState(0)
  const [dragOffsetY, setDragOffsetY] = useState(0)
  const [dragStartPositionX, setDragStartPositionX] = useState(0)
  const [startPositionX, setStartPositionX] = useState(0)
  const divRef = useRef(null)
  const showText = props.text ? props.text : ""
  const position =
    props.position === undefined || props.position === null
      ? "unset"
      : props.position
  const left =
    props.left === undefined || props.left === null ? "unset" : props.left - 2
  const top =
    props.top === undefined || props.top === null ? "unset" : props.top
  const opacity =
    props.opacity === undefined || props.opacity === null ? 1 : props.opacity
  const z = props.zIndex ? props.zIndex : 0

  const getRectanglePositionX = () => {
    //var rect = element.getBoundingClientRect();
    //return { x: rect.left, y: rect.top };
    const e = divRef.current
    if (e === undefined) {
      return 0
    }
    const rect = e.getBoundingClientRect()
    const middleX = rect.left + rect.width / 2

    const parentE = e.offsetParent
    let parentELeft = 0
    if (parentE !== undefined) {
      const parentRect = parentE.getBoundingClientRect()
      parentELeft = parentRect.left
    }

    //console.info("=====getRectanglePosition: ", middleX);
    return middleX - parentELeft
  }

  // useEffect(() => {
  // setDragStartPositionX(getRectanglePositionX())
  // }, [props.x])

  return (
    <Draggable
      bounds={props.bounds}
      position={{ x: 0, y: 0 }}
      onStart={(e, data) => {
        const mouseX = e.clientX
        // console.info("e.clientX start:", mouseX)
        setStartPositionX(getRectanglePositionX())
        setDragStartPositionX(mouseX)
      }}
      onDrag={(e, data) => {
        const mouseX = e.clientX
        // console.info("e.clientX drag:", mouseX)
        const deltaX = mouseX - dragStartPositionX
        props.iprPositionXChanged(props.index, deltaX)
        setDragOffsetX(data.x)
        setDragOffsetY(data.y)
        // console.info("data.x:", data.x)
      }}
      onStop={(e, data) => {
        setDragOffsetX(0)
        setDragOffsetY(0)

        const mouseX = e.clientX
        const deltaX = mouseX - dragStartPositionX
        props.iprDragStoped(props.index, deltaX)
      }}
    >
      <div
        ref={divRef}
        style={{
          width: "14px",
          height: "16px",
          left: left - dragOffsetX,
          top: top - dragOffsetY,
          position: position,
          visibility: props.visibility,
          display: "flex",
          justifyContent: "center",
          alignItems: props.direction === "up" ? "flex-end" : "flex-start",
          // border: "1px solid #999999",
          zIndex: z,
          opacity: opacity,
        }}
      >
        <div
          style={{
            width: "7px",
            height: "16px",
            borderTop:
              props.direction === "down" ? "16px solid #02AFEC" : "0px",
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderBottom:
              props.direction === "up" ? "16px solid #02AFEC" : "0px",
          }}
        />
      </div>
    </Draggable>
  )
}

export default IprIcon2
